// import { useEffect } from 'react';
// import { useLocation } from 'react-router-dom';

// const useGA = () => {
//   const location = useLocation();

//   useEffect(() => {
//     if (window.gtag) {
//       window.gtag('config', 'G-X0N7GVY9KD', {
//         page_path: location.pathname,
//       });
//     }
//   }, [location]);
// };

// export default useGA;
import ReactGA from 'react-ga4';
// Replace with your Google Analytics measurement ID
const MEASUREMENT_ID = 'G-X0N7GVY9KD';

// export const initializeGA = () => {
//   ReactGA.initialize(MEASUREMENT_ID);
// };
export const initializeGA = (userId) => {
  ReactGA.initialize(MEASUREMENT_ID, {
    gaOptions: {
      user_id: userId || null
    }
  });
};

export const logPageView = (pathname, title) => {
    ReactGA.send({ hitType: 'pageview', page: pathname, title: title });
  };
  
  export const logEvent = (eventCategory, eventAction, eventLabel) => {
    ReactGA.event({
      category: eventCategory,
      action: eventAction,
      label: eventLabel,
    });
  };
